<template>
  <div :class="['geoAreas', direction]">
    <div class="geoAreas__name">Geographical area:</div>
    <div class="geoAreas__chips">
      <button
        :class="[
          'geoAreas__chips--chip',
          'chip',
          { selected: geoArea === g.key },
        ]"
        @click="geoAreaClick(g.key)"
        :key="index"
        v-for="(g, index) in geoAreasList"
      >
        {{ g.name.toUpperCase() }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "FilterGeoArea",
  props: {
    direction: {
      type: String,
      default: "row",
    },
  },
  computed: {
    ...mapGetters({
      geoAreasList: "ui/geoAreas",
      geoArea: "ui/geoArea",
    }),
  },

  methods: {
    geoAreaClick(key) {
      this.setGeoArea(key);
      // no need to recalulate totalShare if only geoArea changed
      this.calcData({ excludeTotalShare: true });
    },

    ...mapActions({
      setGeoArea: "ui/setGeoArea",
      calcData: "data/calcData",
    }),
  },
};
</script>

<style lang="scss" scoped>
.geoAreas {
  display: flex;
  height: 100%;
  width: 100%;
  flex-grow: 1;
  margin-left: toRem(20);

  &.row {
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

  &.column {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    div {
      flex-grow: 1;
    }
  }

  &__name {
    @include p-s;
    color: $ui-white;

    .row & {
      margin-right: toRem(10);
    }
  }

  &__chips {
    display: flex;
    flex-direction: row;
    @include link-s;
    flex-shrink: 0;
    margin-right: toRem(10);
    &--chip {
      margin: 0 toRem(3);
      border-radius: toRem(200);
      padding: toRem(7) toRem(10) toRem(5);
      height: fit-content;
      background-color: $white_02;
      transition: background-color 0.3s ease-in-out;
      color: $ui-white;

      &:hover {
        background-color: var(--white_03);
      }

      .column & {
        &:first-of-type {
          margin-left: 0;
        }
      }

      &:hover {
        cursor: pointer;
      }

      &.selected {
        color: $gray_01;
        background-color: $primary-yellow;
      }
    }
  }
}

.mobile,
.tablet {
  .geoAreas {
    margin-left: 0;
    &__chips {
      margin-top: toRem(15);
      padding-bottom: toRem(16.5);
      width: 100%;
      overflow: auto;
      &--chip {
        white-space: nowrap;
      }
    }
  }
}

.tablet {
  .geoAreas {
    margin-left: 0;
    &__chips {
      margin-top: toRem(15);
      padding-bottom: 0;
      width: 100%;
      overflow: auto;
      &--chip {
        white-space: nowrap;
      }
    }
  }
}
</style>
